import { render, staticRenderFns } from "./EnvelopeIcon.vue?vue&type=template&id=2e1a237e&"
import script from "./EnvelopeIcon.vue?vue&type=script&lang=js&"
export * from "./EnvelopeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports